import { render, staticRenderFns } from "./UserEditorScreen.vue?vue&type=template&id=4a635ada&scoped=true&"
import script from "./UserEditorScreen.vue?vue&type=script&lang=js&"
export * from "./UserEditorScreen.vue?vue&type=script&lang=js&"
import style0 from "./UserEditorScreen.vue?vue&type=style&index=0&id=4a635ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a635ada",
  null
  
)

export default component.exports